export default __webpack_public_path__ + "static/media/med.62b4d72d.svg";